import { IScheduledSectionComponent } from '../../../ScheduleComponentPage.interface';
import { ISectionDetailDrawer } from '../SectionDetailDrawer';
import { useManageBackupComponent } from './useManageBackupComponent';

export const useSectionDetailDrawer = (props: ISectionDetailDrawer) => {
  const {
    selectedSection,
    duration,
    onCloseSectionDetailDrawer,
    onUpdateScreensGridSectionsWhenSectionChanges,
    handleSectionComponentChange,
    handleSectionComponentRemove,
  } = props;

  const {
    openBackupComponentListModal,
    backupComponentPreviewModal,
    filterParameters,
    selectedPreviewComponent,
    onAddNewBackup,
    onCloseBackupComponentListModal,
    onSelectBackup,
    onDeleteBackup,
    onReorderBackup,
    onPreviewBackup,
  } = useManageBackupComponent(
    selectedSection,
    onUpdateScreensGridSectionsWhenSectionChanges,
    duration,
  );

  const handleCloseSectionDetailDrawer = () => {
    onCloseSectionDetailDrawer();
  };

  const handleUpdateComponent = (
    updatedComponent: IScheduledSectionComponent,
  ) => {
    const updatedComponents =
      selectedSection.components?.map(
        (component: IScheduledSectionComponent) => {
          return component.uid === updatedComponent.uid
            ? updatedComponent
            : component;
        },
      ) ?? [];

    handleSectionComponentChange?.(updatedComponent);
    onUpdateScreensGridSectionsWhenSectionChanges({
      ...selectedSection,
      components: updatedComponents,
    });
  };

  const onDeletedAssemblyComponent = (
    selectedComponent: IScheduledSectionComponent,
  ) => {
    handleSectionComponentRemove?.(selectedComponent);
    onUpdateScreensGridSectionsWhenSectionChanges({
      ...selectedSection,
      components: selectedSection.components!.filter(
        (component: IScheduledSectionComponent) =>
          component.uid !== selectedComponent.uid,
      ),
    });
  };

  return {
    openBackupComponentListModal,
    backupComponentPreviewModal,
    filterParameters,
    selectedPreviewComponent,
    handleCloseSectionDetailDrawer,
    onDeletedAssemblyComponent,
    onAddNewBackup,
    onCloseBackupComponentListModal,
    onSelectBackup,
    onDeleteBackup,
    onReorderBackup,
    onPreviewBackup,
    handleUpdateComponent,
  };
};
